export default {"src":"/_next/static/media/og-thumbnail.0fdbd5a5.gif","height":630,"width":1200,"blurWidth":0,"blurHeight":0};